import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { USER_AUTH_HEADER } from "../../../../../api"
import AppHeader from "../../../../_shared/components/AppHeader"
import Paragraph from "../../../../_shared/components/Typography/Paragraph"
import useRestList from "../../../../_shared/hooks/useRestList"
import OkIcon from "../../../../_shared/images/ok.png"

// ----------------------------------------------------------------------------

function EditSuccess(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [documents] = useRestList("/documents", USER_AUTH_HEADER)

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    const ListCounter = ({ number }) => (
        <div className="list-counter">{number}</div>
    )

    function renderDocumentList() {
        return (
            <ul className="doc-list">
                {documents?.map((doc, index) => (
                    <li key={doc.id} className="doc">
                        <ListCounter number={index + 1} />
                        <a className="doc-link" href={doc.url}>
                            {doc.title}
                        </a>
                    </li>
                ))}
            </ul>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------
    const downloadPrompt =
        documents?.length > 1
            ? "Nel frattempo <b>scarica questi documenti</b> e "
            : "Nel frattempo <b>scarica questo documento</b> e "
    const downloadPrompt2 =
        documents?.length > 1
            ? "portali compilati il giorno dell'appuntamento."
            : "portalo compilato il giorno dell'appuntamento."
    return (
        <div className={props.className}>
            <AppHeader />
            <main>
                <h1 className="screen-title">
                    <img src={OkIcon}></img>
                    <span>Prenotazione modificata correttamente!</span>
                </h1>
                <Paragraph className="paragraph">
                    {"A breve riceverai una mail di conferma con tutti i dettagli della tua prenotazione.<br>" +
                        "Per rientrare nella tua prenotazione dal nostro sito, inserisci se necessario il codice fiscale ed entrerai automaticamente nella sezione “Le tue prenotazioni”.<br />" +
                        downloadPrompt +
                        downloadPrompt2}
                </Paragraph>
                {renderDocumentList()}
            </main>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

EditSuccess.propTypes = {
    className: PropTypes.string.isRequired,
}

EditSuccess.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledEditSuccess = styled(EditSuccess)`
    & {
        main {
            padding-top: 80px;
            display: flex;
            align-items: center;
            flex-direction: column;
            h1 {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                img {
                    margin-right: 10px;
                }
                span {
                    font-size: 32px;
                    color: ${({ theme }) => theme.colors.success};
                    font-family: "Poppins-Bold";
                }
            }
            .paragraph {
                margin-top: 25px;
                margin-bottom: 70px;
                text-align: center;
                padding: 0px 30px;
            }
            .doc-list {
                list-style: none;
                margin: 0;
                padding: 0;
                .doc {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 20px;
                    .doc-link {
                        text-decoration: underline;
                        font-family: "Poppins-Bold";
                        font-size: 16px;
                        color: ${({ theme }) => theme.colors.textPrimary};
                    }
                    .list-counter {
                        width: 25px;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid black;
                        border-radius: 999px;
                        margin-right: 20px;
                        font-family: "Poppins-Bold";
                        font-size: 12px;
                    }
                }
            }
        }
        @media (max-width: 768px) {
            h1 {
                width: 75% !important;
                text-align: center;
                flex-direction: column !important;
                img {
                    margin-bottom: 20px;
                    margin-right: 0px !important;
                }
            }
        }
        @media (max-width: 576px) {
            .paragraph {
                padding: 0px 30px;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledEditSuccess
